import {
  Box,
  Divider,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@mui/material";
import { useFeatureFlags } from "~/providers/FeatureFlagsProvider";

export const PriorityFindingsSkeleton = () => {
  const { isFeatureEnabled } = useFeatureFlags();
  const isMoveTheNeedleFeatureEnabled = !isFeatureEnabled("Move the needle");

  return (
    <>
      {isMoveTheNeedleFeatureEnabled && (
        <>
          <Box sx={{ paddingBottom: "3px" }}>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Stack direction="row" spacing={1} alignItems="center">
                <Skeleton
                  variant="text"
                  width={80}
                  height={40}
                  animation="wave"
                />
                <Skeleton
                  variant="text"
                  width={60}
                  height={40}
                  animation="wave"
                />
              </Stack>
              <Skeleton
                variant="rectangular"
                width={80}
                height={40}
                animation="wave"
                sx={{ borderRadius: 1 }}
              />
            </Box>

            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Stack direction="row" alignItems="center">
                <Skeleton
                  variant="text"
                  width={100}
                  height={40}
                  animation="wave"
                />
              </Stack>
              <Stack direction="row" spacing={1} alignItems="center">
                <Skeleton
                  variant="text"
                  width={40}
                  height={40}
                  animation="wave"
                />
                <Skeleton
                  variant="text"
                  width={50}
                  height={40}
                  animation="wave"
                />
                <Skeleton
                  variant="rectangular"
                  width={50}
                  height={24}
                  animation="wave"
                  sx={{ borderRadius: 1 }}
                />
              </Stack>
            </Box>
          </Box>

          <Divider sx={{ mt: 1, mb: 1 }} />
        </>
      )}

      {/* Table of findings */}
      <Table>
        <TableBody sx={{ "& td": { pl: 0, py: 1, borderBottom: "none" } }}>
          {Array.from({ length: isMoveTheNeedleFeatureEnabled ? 9 : 5 }).map(
            (_, i) => (
              <TableRow key={i}>
                <TableCell width={50}>
                  <Skeleton
                    variant="circular"
                    width={24}
                    height={24}
                    animation="wave"
                  />
                </TableCell>
                <TableCell width={100}>
                  <Skeleton
                    variant="rectangular"
                    height={20}
                    animation="wave"
                    sx={{ borderRadius: 1 }}
                  />
                </TableCell>
                <TableCell width={100}>
                  <Skeleton
                    variant="rectangular"
                    width={60}
                    height={20}
                    animation="wave"
                    sx={{ borderRadius: 1 }}
                  />
                </TableCell>
                <TableCell width={"60%"}>
                  <Skeleton
                    variant="text"
                    height={20}
                    sx={{ borderRadius: 1 }}
                    animation="wave"
                  />
                </TableCell>
              </TableRow>
            ),
          )}
        </TableBody>
      </Table>
    </>
  );
};
